import type { BillingItemResource } from '../../../Entities/BillingItem';
import { isNil } from 'lodash';
import { DeepPartial, not } from '../../../utils';

export default function calculateTransactionDate(
  billingItems: DeepPartial<BillingItemResource>[],
): Date {
  // grab the most recent billing item date
  const dates = billingItems
    .map((bi) => bi?.attributes?.month_billed)
    .filter(not(isNil))
    .map((date) => new Date(date))
    .filter((date) => !isNaN(date.getTime())); // filter out invalid dates

  if (dates.length === 0) {
    // return the last day of the previous month if no valid dates found
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
  }

  const mostRecentDate = new Date(Math.max(...dates.map((date) => date.getTime())));

  // return the last day of that month
  return new Date(mostRecentDate.getFullYear(), mostRecentDate.getMonth() + 1, 0, 23, 59, 59, 999);
}
